/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Modal, ModalBody} from "reactstrap";

const CenterModal = (props) => {
  const { children, noBody } = props;
  return (
    <Modal centered {...props}>
      {noBody ? children : <ModalBody>{children}</ModalBody>}
    </Modal>
  );
};

export default CenterModal;
